import { allData } from '../app'
import { getFirebaseIdToken } from './firebase'

const environment = process.env.NODE_ENV || 'development'
export const serverUrl = getServerUrl(environment)
const baseUrl = `${serverUrl}/api/firebase`

function getServerUrl(mode) {

	if (local) return 'http://localhost:9015'

	return {
		production: 'https://sanatanadharma.world',
		development: 'https://dev.sanatanadharma.world',
		local: 'http://localhost:9015'
	}[mode]
}

export async function updateLecturesInAdvayta(item) {
	return await request(`${baseUrl}/lectures`, 'POST', item)
}

export async function updateBookInAdvayta(body) {
	body = replaceValues(body)
	return await request(`${baseUrl}/books/${body.key}`, 'PATCH', body)
}

export async function checkBookExistsInAdvayta(title) {
	return await request(`${baseUrl}/books/checkExists`, 'POST', { title })
}

export async function removeBookFromAdvayta(key) {
	return await request(`${baseUrl}/books/remove`, 'POST', { key })
}

export async function removeLectureFromAdvayta(key) {
	return await request(`${baseUrl}/lectures/remove`, 'POST', { key })
}

export async function createTagInAdvayta(body) {
	return await request(`${baseUrl}/tags`, 'POST', body)
}

export async function updateTagInAdvayta(body) {
	return await request(`${baseUrl}/tags`, 'PATCH', body)
}

export async function removeTagFromAdvayta(key) {
	return await request(`${baseUrl}/tags/${key}`, 'DELETE')
}

export async function uploadFileToTemp(file) {
	const formData = new FormData()
	formData.append('file[]', file)
	formData.append('name[]', encodeURIComponent(file.name))

	const response = await fetch(`${serverUrl}/api/file/upload/tmp`, {
		method: 'POST',
		headers: await getFirebaseAuthorizationHeaders(),
		body: formData
	})

	return response.ok ? await response.json() : false
}

export async function getAudioDuration(path) {
	const response = await request(`${baseUrl}/audio/duration?path=${encodeURIComponent(path)}`, 'GET')
	return response
}

export async function createAudioFileType(body) {
	return await request(`${baseUrl}/audiofile-types`, 'POST', body)
}

export async function removeAudioFileType(key) {
	return await request(`${baseUrl}/audiofile-types/${key}`, 'DELETE')
}

export async function updateAudioFileType(body) {
	return await request(`${baseUrl}/audiofile-types/${body.key}`, 'PATCH', body)
}

export async function createAudioFileSinger(body) {
	return await request(`${baseUrl}/audiofile-singers`, 'POST', body)
}

export async function updateAudioFileSinger(body) {
	return await request(`${baseUrl}/audiofile-singers/${body.key}`, 'PATCH', body)
}

export async function removeAudioFileSinger(key) {
	return await request(`${baseUrl}/audiofile-singers/${key}`, 'DELETE')
}

export async function createAudioFileTag(body) {
	return await request(`${baseUrl}/audiofile-tags`, 'POST', body)
}

export async function updateAudioFileTag(body) {
	return await request(`${baseUrl}/audiofile-tags/${body.key}`, 'PATCH', body)
}

export async function removeAudioFileTag(key) {
	return await request(`${baseUrl}/audiofile-tags/${key}`, 'DELETE')
}

export async function createAudioFile(body) {
	return await request(`${baseUrl}/audiofiles`, 'POST', body)
}

export async function updateAudioFile(body) {
	return await request(`${baseUrl}/audiofiles/${body.key}`, 'PATCH', body)
}

export async function removeAudioFile(key) {
	return await request(`${baseUrl}/audiofiles/${key}`, 'DELETE')
}

export async function getSupabaseLectures(date) {
	return await request(`${baseUrl}/supabase?date=${encodeURIComponent(date)}`, 'GET')
}

export async function generatePreview(promptText) {
	return await request(`${baseUrl}/generate-preview`, 'POST', { text: promptText })
}

function replaceValues(body) {
	for (const key in body) {
		if (!allData[key] || !(body[key] in allData[key])) continue
		body[key] = allData[key][body[key]].value
	}
	return body
}

async function request(url = baseUrl, method = 'POST', body) {
	const response = await fetch(url, {
		method,
		headers: {
			'Content-Type': 'application/json',
			...await getFirebaseAuthorizationHeaders()
		},
		body: JSON.stringify(body)
	})

	const data = await response.json()

	if (!response.ok) {
		const errorMessage = data.message || data.error || 'Ошибка сервера'
		return { error: errorMessage }
	}

	return data
}

export async function getFirebaseAuthorizationHeaders() {
	const token = await getFirebaseIdToken()
	return { Authorization: `Bearer ${token}` }
}
